import { useSuspenseQuery } from '@tanstack/react-query'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useCurrentProject } from '../useCurrentProject'
import { getProjectOrganisationId } from '../useUserLinkedProjects'

export type ListProjectFilesResult = RestSchemas['Messages.Storage.ListProjectFilesResult']

export const LIST_PROJECT_FILES_QUERY_KEY = 'listProjectFiles'

export function getListProjectFilesQueryKey(
  projectId: number,
  organisationId: number | undefined,
  namespace: string
) {
  return [LIST_PROJECT_FILES_QUERY_KEY, projectId, organisationId, namespace] as const
}

export function useGetProjectFiles(namespace: string | null | undefined) {
  const { postStorageApiListProjectFiles } = useRestClient()
  const project = useCurrentProject()
  const organisationId = getProjectOrganisationId(project)

  return useSuspenseQuery({
    queryKey: getListProjectFilesQueryKey(project.projectId, organisationId, namespace ?? ''),
    queryFn: async ({ signal }) => {
      if (organisationId == null) {
        throw new Error('Missing organisationId for project files')
      }

      const response = await postStorageApiListProjectFiles({
        signal,
        body: {
          projectId: project.projectId,
          organisationId,
          namespace: namespace ?? '',
        },
      })

      if ('error' in response && response.error) {
        throw response.error
      }

      return response.data
    },
  })
}
